// tabbar items
const items = [
  {
    url: 'https://m.zhuokao360.com/',
    text: '官网首页',
    icon: require('assets/img/tabbar/home.png'),
  },
  {
    url: 'https://m.zhuokao360.com/plan/',
    text: '学习计划',
    icon: require('assets/img/tabbar/plan.png'),
  },
  {
    url: 'https://m.zhuokao360.com/contact/',
    text: '联系我们',
    icon: require('assets/img/tabbar/contact.png'),
  },
];

export default items;
